import {Component, OnInit, ViewChild} from '@angular/core';
import {WelfareResultService} from '@core/service/welfare-result.service';
import {WelfareProjectResult} from '@core/class/result/welfare-project-result';
import {SafeguardResult} from '@core/class/result/safeguard-result';
import {Router} from '@angular/router';
import {Person} from '@core/class/person';
import {Util} from '@core/util/util';
import {PersonKind} from '@core/class/person-kind.enum';
import {QuoteRowObject} from '@core/class/quote/quote-row-object';
import {QuoteChartComponent} from '@core/components/quote/quote-chart/quote-chart.component';

interface ChartItem {
  name: string;
  value: number;
}

@Component({
  selector: 'app-prev-area',
  templateUrl: './prev-area.component.html',
  styleUrls: ['./prev-area.component.css']
})
export class PrevAreaComponent implements OnInit {
  prices: ChartItem [] = [
    {
      name: 'Morte',
      value: 0
    },
    {
      name: 'IP Capitale',
      value: 0
    },
    {
      name: 'IP Rendita',
      value: 0
    },
    {
      name: 'Non Autosufficenza',
      value: 0
    },
    {
      name: 'Grave patologia (D.D)',
      value: 0
    },
    {
      name: 'Terremoto',
      value: 0
    },
    {
      name: 'Incendio',
      value: 0
    },
    {
      name: 'Servizio Fisio',
      value: 0
    },
    {
      name: 'Servizio Fisio',
      value: 0
    },
    {
      name: 'Servizio Dental',
      value: 0
    },
    {
      name: 'Extraricovero gp',
      value: 0
    },
    {
      name: 'RSC gravi patologie',
      value: 0
    },
    {
      name: 'RSC extraricovero',
      value: 0
    },
    {
      name: 'RSC ricovero',
      value: 0
    },
  ];

  view: number[] = [450, 600];
  priceView: number[] = [1000, 480];

  colorScheme = {
    domain: ['#5AA454']
  };

  colorScheme2 = {
    domain: ['#a44800']
  };

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  chartPadding = 20;

  firstPerson: Person;
  private projectResult: WelfareProjectResult;
  protected safeGuardResult: SafeguardResult;
  public secondPerson: Person;
  total = 0;

  @ViewChild('firstPersonChart')
  firstPersonChart: QuoteChartComponent;

  @ViewChild('secondPersonChart')
  secondPersonChart: QuoteChartComponent;

  constructor(private welfareService: WelfareResultService, private route: Router) {
    this.projectResult = welfareService.projectResult;
  }

  ngOnInit() {

    if (this.welfareService.isSingle()) {
      this.firstPerson = Util.getPersonByKind(this.welfareService.persons, PersonKind.SINGLE);
    } else {
      this.firstPerson = Util.getPersonByKind(this.welfareService.persons, PersonKind.HUSBAND);
      this.secondPerson = Util.getPersonByKind(this.welfareService.persons, PersonKind.WIFE);
    }

    if (this.projectResult) {
      this.safeGuardResult = this.projectResult.safeguardResult;
    } else {
      this.route.navigate(['/simulations']);
    }
  }

  updateCover(cover: QuoteRowObject) {
    if (cover.obj && cover.obj.kind) {
      // update single chart
      if (cover.obj.name === this.firstPerson.name) {
        this.firstPersonChart.updateChart(cover);
      } else if (cover.obj.name === this.secondPerson.name) {
        this.secondPersonChart.updateChart(cover);
      }
    } else {
      // update both
      this.firstPersonChart.updateChart(cover);
      this.secondPersonChart.updateChart(cover);
    }
  }

  updatePrice(event) {
    if (event) {
      const price = event.price;
      const type = event.type;
      this.total = 0;

      this.prices.forEach(chartItem => {
        if (chartItem.name === this.getItemNameByType(type)) {
          chartItem.value = price;
        }
        this.total += chartItem.value;
      });
    }
    this.prices = [...this.prices];
  }

  private getItemNameByType(type: number) {
    switch (type) {
      case 0: {
        return 'Morte';
      }
      case 1: {
        return 'IP Capitale';
      }
      case 2: {
        return 'IP Rendita';
      }
      case 3: {
        return 'Non Autosufficenza';
      }
      case 4: {
        return 'Grave patologia (D.D)';
      }
      case 5: {
        return 'Terremoto';
      }
      case 6: {
        return 'Incendio';
      }
      case 7: {
        return 'Servizio Fisio';
      }
      case 8: {
        return 'Servizio Dental';
      }
      case 9: {
        return 'Extraricovero gp';
      }
      case 10: {
        return 'RSC gravi patologie';
      }
      case 11: {
        return 'RSC extraricovero';
      }
      case 12: {
        return 'RSC ricovero';
      }
    }
  }
}
